import React from "react";
import { SERVICE_DOMAIN } from "../../../s3-assets/ServiceDomain";



const WhyChooseUsSection = () => {
    return (
        <section className="bg-gradient-to-r from-[#f5f9fc] to-[#eaf4fb] py-16">
            <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center gap-8">
                {/* Left Side - Content */}
                <div className="lg:w-1/2 space-y-6">
                    <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Choose Us?</h2>
                    <ul className="space-y-4 text-gray-600 text-lg">
                        <li className="flex items-center">
                            <span className="mr-3 text-blue-600">🛡️</span>
                            Secure Payment With PayU or RazorPay
                        </li>
                        <li className="flex items-center">
                            <span className="mr-3 text-blue-600">⏰</span>
                            24/7 Customer Support
                        </li>
                        <li className="flex items-center">
                            <span className="mr-3 text-blue-600">🌟</span>
                            3000+ Customer Review
                        </li>
                        <li className="flex items-center">
                            <span className="mr-3 text-blue-600">🏠</span>
                            Short-term or long-term rentals—find what suits you
                        </li>
                    </ul>
                    <button className="bg-blue-600 text-white px-6 py-3 shadow-md hover:bg-blue-700 mt-6">
                        Learn More
                    </button>
                </div>

                {/* Right Side - Images */}
                <div className="lg:w-1/2 relative">
                    {/* Top Large Image */}
                    <img
                        src={SERVICE_DOMAIN.IMAGE_2} alt="Property 1"
                        className=" shadow-lg w-full border-4 border-white"
                    />

                </div>
            </div>
        </section>
    );
};

export default WhyChooseUsSection;
